import { Logger } from '@/js/utils/Logger.js';
import { AcrylProductIds, AcrylTicketIds, AcrylSampleProductIds } from "@/js/Const.js";

function sendConfig(params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("config", "G-SRM3N0RG48", params);
    Logger.debug("[GA4 config send]", params);
  } else {
    Logger.debug("[GA4 config skipped]", params);
  }
}

function sendEvent(name, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", name, params);
    Logger.debug("[GA4 event send]", name, params);
  } else {
    Logger.debug("[GA4 event skipped]", name, params);
  }
}

export const Analytics = {

  // 新規登録
  signUp(method) {
    sendEvent("sign_up", { method });
  },

  // ログイン
  login(method) {
    sendEvent("login", { method });
  },

  // UserIdの設定
  setUserId(userId) {
    if (userId) {
      // ログイン時に呼ぶ
      sendConfig({ user_id: userId });
    } else {
      // ログアウト時に呼ぶ（クリア）
      sendConfig({ user_id: undefined });
    }
  },

  // フォームに個人情報を入力
  piiFormCompleted() {
    sendEvent("pii_form_completed");
  },

  // 契約書を送信
  contractSubmitted() {
    sendEvent("contract_submitted");
  },

  // 契約書にサイン完了
  contractSigned() {
    sendEvent("contract_signed");
  },

  // 作成ボタンをクリック
  createButtonClick(size, isSample = false){
    sendEvent("create_button_click", { size: size, sample: isSample });
  },

  // デザインコード（ACRY PROコード）を入力
  designCodeInput(code, size, isSample = false) {
    sendEvent("design_code_input", { code: code, size: size, sample: isSample });
  },

  // テンプレートダウンロード
  designTemplateDownload(size){
    sendEvent("design_template_download", { size: size });
  },

  // カート追加（アクリル）
  addToCartAcrylic( itemId, itemName, quantity, price, size, simple = false ) {
    sendEvent("add_to_cart",
      { currency: "JPY",
        value: quantity * price,
        items:[
        {
          item_id: itemId,
          item_name: itemName,
          item_category: 'acrylic',
          quantity: quantity,
          price: price, // 単価
          acrylic_size: size,
          simple: simple,
    }] });
  },

  // カート追加（オプション品）
  addToCartOption( itemId, itemName, quantity, price ) {
    sendEvent("add_to_cart",
      { currency: "JPY",
        value: quantity * price,
        items:[
        {
          item_id: itemId,
          item_name: itemName,
          item_category: 'option',
          quantity: quantity,
          price: price, // 単価
    }] });
  },

  // 購入
  purchase( orderId, orderData, productData ) {
    let items = [];
    productData.forEach(product => {
      let item = {};
      item.item_id = product.product_id;
      item.item_name = product.product_name;
      item.quantity = product.quantity;
      item.price = product.price_base;

      if( AcrylProductIds.includes(product.product_id) ){
        item.item_category = 'acrylic';
      }else if( AcrylSampleProductIds.includes(product.product_id) ){
        item.item_category = 'sample';
      }else if( AcrylTicketIds.includes(product.product_id) ){
        item.item_category = 'ticket';
      }else{
        item.item_category = 'option';
      }

      items.push(item);
    });

    sendEvent("purchase", {
      transaction_id: orderId,
      currency: "JPY",
      value: orderData.payment_total,
      tax: orderData.tax + orderData.deliv_fee_tax,
      shipping: orderData.deliv_fee_base,
      items:items,
    });
  },

  // ACRY TICKET作成ボタンクリック
  acryTicketCreateButtonClick() {
    sendEvent("acry_ticket_create_button_click");
  },

  // ACRY TICKET STEP1完了
  acryTicketStep1Completed() {
    sendEvent("acry_ticket_step1_completed");
  },

  // ACRY TICKET STEP2完了
  acryTicketStep2Completed() {
    sendEvent("acry_ticket_step2_completed");
  },

  // ACRY TICKET STEP3完了
  acryTicketStep3Completed() {
    sendEvent("acry_ticket_step3_completed");
  },

  // ACRY TICKETチケット発行
  acryTicketIssueTicket( quantity, size, userEdit, shippingFee ) {
    sendEvent("acry_ticket_issue_ticket", { quantity: quantity, size: size, userEdit: userEdit, shippingFee: shippingFee });
  },



  // ページビュー（SPA遷移時など）
  pageView(path = location.pathname) {
    sendEvent("page_view", {
      page_title: document.title,
      page_location: location.href,
      page_path: path,
    });
  },






  // 任意のクリックイベント
  click(label, extra = {}) {
    sendEvent("ui_click", { ui_label: label, ...extra });
  },

  // 検索
  search(term) {
    sendEvent("search", { search_term: term });
  },




  // 任意のイベント（汎用）
  track(name, params = {}) {
    sendEvent(name, params);
  },
};